import React from 'react'
import { Field, Form } from 'redux-form'

import Input from 'components/Input/Input/Input'
import Button from 'components/Button'
import LoadingLinear from 'components/Loading/LoadingLinear'
import { vPassword, vPasswordIdentical, vRequired } from 'components/Input/Input.validations'

export default props => {
  const {
    handleSubmit,
    invalid,
    showConfirmModal,
    updatePassword,
    closeModal,
    passwordUpdateLoading,
  } = props

  const submit = ({ password, oldPassword }) => {
    console.log('change password submit', { password, oldPassword })
    showConfirmModal({
      message: 'Are you sure?',
    }).then(() =>
      updatePassword({
        password,
        oldPassword,
      })
        .then(() =>
          showConfirmModal({
            message: 'Password changed successfully',
          })
        )
        .finally(() => closeModal())
    )
  }

  if (passwordUpdateLoading) {
    return (
      <div>
        Updating password...
        <br />
        <br />
        <LoadingLinear />
      </div>
    )
  }

  return (
    <Form onSubmit={handleSubmit(submit)}>
      <Field
        label="Old Password"
        name="oldPassword"
        type="password"
        component={Input}
        validate={[vRequired]}
      />

      <Field
        label="New Password"
        name="password"
        type="password"
        component={Input}
        validate={[vRequired, vPassword]}
      />

      <Field
        label="Confirm Password"
        name="confirmPassword"
        type="password"
        component={Input}
        validate={[vRequired, vPassword, vPasswordIdentical]}
      />

      <Button type="submit" color="warn" disabled={invalid}>
        Change Password
      </Button>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ChangePasswordForm/ChangePasswordForm.jsx